// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-banner a, .header-banner a:visited {\n  color: white;\n  text-decoration: underline;\n}\n\n.header-banner p {\n  margin: 0;\n}\n\n.header-banner.dismissed p {\n  font-size: 0;\n  line-height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
